import { render, staticRenderFns } from "./FavoriteSwitcher.vue?vue&type=template&id=72feed5f&scoped=true&"
import script from "./FavoriteSwitcher.vue?vue&type=script&lang=js&"
export * from "./FavoriteSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feed5f",
  null
  
)

export default component.exports